import { render } from "./VaIconNotification.vue?vue&type=template&id=a154dcac"
import script from "./VaIconNotification.vue?vue&type=script&lang=js"
export * from "./VaIconNotification.vue?vue&type=script&lang=js"

import "./VaIconNotification.vue?vue&type=style&index=0&id=a154dcac&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__